/*
 * Campaign visits (the app's campaign report).
 *
 * Only for someone who arrived from a House of Daisy WhatsApp campaign
 * button: the link carries ?hod_c=<code>. For seven days after that, this
 * reports each page she opens, how long it stays on her screen, and anything
 * she adds to her bag, to /apps/hod/track; and it puts the code on her cart
 * (a hidden cart attribute) so her order can be linked to the campaign.
 * Anyone else: nothing is recorded or sent.
 *
 * Respects Shopify's customer privacy setting: if analytics are declined,
 * nothing is sent.
 */
(function () {
  var KEY = 'hodCampaign';
  var DAYS = 7;
  var CODE = /^[A-Za-z0-9]{10}$/;
  var page = window.hodPage || {};

  function remembered() {
    try {
      var v = JSON.parse(localStorage.getItem(KEY) || 'null');
      if (v && CODE.test(v.c) && Date.now() - v.t < DAYS * 864e5) return v.c;
    } catch (e) {}
    return null;
  }

  var fromLink = new URLSearchParams(location.search).get('hod_c');
  if (fromLink && CODE.test(fromLink)) {
    try {
      localStorage.setItem(KEY, JSON.stringify({ c: fromLink, t: Date.now() }));
    } catch (e) {}
  } else {
    fromLink = null;
  }
  var code = fromLink || remembered();
  if (!code) return;

  // With the theme's own banner asking everyone, only her explicit "yes" counts: Shopify's API says "allowed" before
  // she has chosen where no law requires asking (India), so a campaign visit went while the banner was still asking
  // (a review, 2026-09-29). Without our banner, Shopify's answer. No consent API at all: never.
  function consentFor(kind) {
    var P = window.Shopify && window.Shopify.customerPrivacy;
    if (!P) return false;
    var banner = document.querySelector('section[data-hod-consent]');
    if (banner && banner.dataset.who !== 'regions') {
      var v = P.currentVisitorConsent && P.currentVisitorConsent();
      return !!v && v[kind] === 'yes';
    }
    var fn = kind === 'analytics' ? P.analyticsProcessingAllowed : P.marketingAllowed;
    return !!fn && fn.call(P) !== false;
  }

  function allowed(done) {
    var S = window.Shopify;
    if (!S || !S.loadFeatures) return done(false);
    if (S.customerPrivacy) return done(consentFor('analytics'));
    S.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function (err) {
      done(!err && consentFor('analytics'));
    });
  }

  function uuid() {
    if (window.crypto && crypto.randomUUID) return crypto.randomUUID();
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
      var r = (Math.random() * 16) | 0;
      return (c === 'x' ? r : (r & 3) | 8).toString(16);
    });
  }

  // Asked again at every send: she may have answered the cookie banner since the page loaded (a review, 2026-09-29:
  // after "Only what is needed", the time on the page and bag adds still went).
  function stillAllowed() {
    return consentFor('analytics');
  }

  function send(kind, extra) {
    if (!stillAllowed()) return;
    var f = new FormData();
    f.append('c', code);
    f.append('v', view);
    f.append('k', kind);
    for (var k in extra) if (extra[k] != null) f.append(k, extra[k]);
    try {
      fetch('/apps/hod/track', { method: 'POST', body: f, keepalive: true, headers: { Accept: 'application/json' } });
    } catch (e) {}
  }

  var view = uuid();

  allowed(function (ok) {
    if (!ok) return;

    send('page', { path: location.pathname, type: page.type, product_id: page.product, title: page.title || document.title });

    // Time on screen: only while the page is visible.
    var shownAt = document.visibilityState === 'visible' ? Date.now() : null;
    var seconds = 0;
    function report() {
      if (shownAt) {
        seconds += (Date.now() - shownAt) / 1000;
        shownAt = null;
      }
      send('time', { s: Math.round(seconds) });
    }
    document.addEventListener('visibilitychange', function () {
      if (document.visibilityState === 'hidden') report();
      else shownAt = Date.now();
    });
    window.addEventListener('pagehide', report);

    // She declines measuring: forget the campaign on this phone and take its code off her cart.
    document.addEventListener('visitorConsentCollected', function () {
      if (stillAllowed()) return;
      try {
        localStorage.removeItem(KEY);
        sessionStorage.removeItem('hodCampaignCart');
      } catch (e) {}
      fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ attributes: { _hod_c: '' } }),
      }).catch(function () {});
    });

    // The code rides on her cart, so the order carries it (once per visit).
    try {
      if (sessionStorage.getItem('hodCampaignCart') !== code) {
        fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ attributes: { _hod_c: code } }),
        }).then(function (r) {
          if (r.ok) sessionStorage.setItem('hodCampaignCart', code);
        });
      }
    } catch (e) {}

    // Added to bag: watch the theme's own add-to-cart requests.
    var original = window.fetch;
    window.fetch = function (input, init) {
      var url = typeof input === 'string' ? input : input && input.url;
      var p = original.apply(this, arguments);
      if (url && /\/cart\/add(\.js)?(\?|$)/.test(url)) {
        p.then(function (r) {
          if (r.ok) send('bag', { path: location.pathname, product_id: page.product, title: page.title || document.title });
        }).catch(function () {});
      }
      return p;
    };
  });
})();
